import BulkOperationWarningDialogCmp from "../BulkOperationWarningDialog/BulkOperationWarningDialogCmp.js";

export default class ResourceBulkAction {
    /** @type {Map<string, InjectionMetaJson|BatchListEntry>} */
    #resources;
    #warningDialogCmp = new BulkOperationWarningDialogCmp();

    /** @param {Map<string, InjectionMetaJson|BatchListEntry|Post>} resources */
    constructor(resources) {
        this.#resources = resources;
    }

    /**
     * @param {string[]} resourceIds
     * @param {AccessLevel} accessLevel
     * @param {function} actionCallback
     * @param {function} onCancelCallback
     * @returns {Promise<void>}
     */
    async checkAccessLevelAndPerform(resourceIds, accessLevel, actionCallback, onCancelCallback = ()=>{}) {
        const {accessible, notAccessible} =
            this.#checkInjectionsAccess(resourceIds, accessLevel);
        if (notAccessible.length > 0) {
            this.#warningDialogCmp.show(
                accessible.map(i => i.name), notAccessible.map(i => i.name));
            this.#warningDialogCmp.onOk(async () => {
                try {
                    await actionCallback(accessible.map(i => i.id));
                } catch (err) {
                    this.#warningDialogCmp.close();
                    throw err
                }
            });
            this.#warningDialogCmp.onClose(onCancelCallback);
        } else
            await actionCallback(resourceIds);
    }

    /**
     * @param {string[]} resourceIds
     * @param {AccessLevel} requiredLevel
     * @returns {{accessible: InjectionMetaJson[]|BatchListEntry[], notAccessible: InjectionMetaJson[]|BatchListEntry[]}}
     */
    #checkInjectionsAccess(resourceIds, requiredLevel) {
        const accessible = [], notAccessible = [];
        for (let id of resourceIds) {
            const resource = this.#resources.get(id);
            if (resource.userAccessLevel.meetsOrExceeds(requiredLevel))
                accessible.push(resource);
            else
                notAccessible.push(resource);
        }
        return {accessible, notAccessible};
    }
}